export const checkStatus = response => {
  if (!response.ok) {
    // status in the range 200-299 or not

    return Promise.reject(
      response.text().then(text => {
        const parsedResponse = text ? JSON.parse(text) : {}
        const error = new Error(parsedResponse.msg || parsedResponse.message || response.statusText)
        error.status = response.status
        if (typeof parsedResponse === 'object') {
          throw Object.assign({}, error, {
            parsedResponse
          })
        }
        throw error
      })
    )
  }

  return response
}

export const parseJSON = response => response.json()

export const parseError = error =>
  error.then(err => {
    throw err
  })

export default (url, options) =>
  fetch(url, options)
    .then(checkStatus)
    .then(parseJSON)
    .catch(parseError)
